var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_32351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.9998 50.3066C99.9998 22.5191 77.6123 -0.00585938 49.9998 -0.00585938C22.3748 0.000390625 -0.0126953 22.5191 -0.0126953 50.3129C-0.0126953 75.4191 18.2748 96.2316 42.1748 100.007V64.8504H29.4873V50.3129H42.1873V39.2191C42.1873 26.6129 49.6561 19.6504 61.0748 19.6504C66.5498 19.6504 72.2686 20.6316 72.2686 20.6316V33.0066H65.9623C59.7561 33.0066 57.8186 36.8879 57.8186 40.8691V50.3066H71.6811L69.4686 64.8441H57.8123V100C81.7123 96.2254 99.9998 75.4129 99.9998 50.3066Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_32351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3c26a6e8ccfca3b72f0aa5046dbc6954.svg";
export { ForwardRef as ReactComponent };